export class CertificationsFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getCertifications(filter) {
    return this.instance.get('/v1/certifications', {
      params: filter || null,
    });
  }

  getCertification(id) {
    return this.instance.get(`/v1/certifications/${id}`);
  }

  createCertification(data) {
    return this.instance.post('/v1/certifications', data);
  }

  updateCertification(id, data) {
    return this.instance.put(`/v1/certifications/${id}`, data);
  }

  getStandardGroups(certificationId, filters) {
    return this.instance.get(
      `/v1/certifications/${certificationId}/standard-groups`,
      {
        params: filters || null,
      },
    );
  }

  getCertificationsStandard(certificationId, filters) {
    return this.instance.get(
      `/v1/certifications/${certificationId}/certifications-standard`,
      {
        params: filters || null,
      },
    );
  }

  getCustomFields(certificationId) {
    return this.instance.get(
      `/v1/certifications/${certificationId}/custom-fields`,
    );
  }

  createCertificationNormData(data) {
    return this.instance.post('/v1/certification-norm-data', data);
  }

  listCertificationNormData(certificationId) {
    return this.instance.get(`/v1/certification-norm-data`, {
      params: { myCertificationId: certificationId } || null,
    });
  }
}

export default CertificationsFactory;
